module.exports = __webpack_public_path__ + "img/bg3.76076e47.png";